var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model } from 'vue-property-decorator';
import Hours from '@/components/hours/Hours';
import { Teacher } from '@/models/Teacher';
let ContractHours = class ContractHours extends Vue {
    mounted() {
        //
    }
    initialize() {
        //
    }
};
__decorate([
    Model('teacher', { default: () => new Teacher() }),
    __metadata("design:type", typeof (_a = typeof Teacher !== "undefined" && Teacher) === "function" ? _a : Object)
], ContractHours.prototype, "teacher", void 0);
ContractHours = __decorate([
    Component({
        components: {
            Hours,
        },
    })
], ContractHours);
export default ContractHours;
